export const Mixins = {
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      sessionStorage.removeItem("keyStatic");
      sessionStorage.removeItem("keywordChange");
      // 如果有bindThLogin，说明为第三方登录绑定，如果没有在判断是不是 个人中心的绑定第三方。
      if (location.href.indexOf("bindThLogin") == -1) {
        if (
          location.href.indexOf("code=") != -1 &&
          location.href.indexOf("personal") > 0 &&
            (!window.localStorage.getItem("memberId") ||
              !window.localStorage.getItem("memberId") == null ||
              !window.localStorage.getItem("memberId") == "null")
        ) {
          this.$message.warning("请先登录");
          // this.$router.push("/login");
        }
      } else {
        let url = location.href;
        let star = url.indexOf("code=");
        let end = url.indexOf("&state");
        let code = url.substring(star + 5, end);

        let loginProviderIdstar = url.indexOf("loginProviderId=");
        let loginProviderIdend = url.indexOf("&service");
        let loginProviderIdcode = url.substring(
          loginProviderIdstar + 16,
          loginProviderIdend
        );
        localStorage.setItem("loginProviderId", loginProviderIdcode);
        this.$router.push({
          path: "/thirdLogin",
          query: {
            code: code,
            loginProviderId: loginProviderIdcode
          }
        });
      }
    });
  },
  created() {},
  methods: {}
};



// WEBPACK FOOTER //
// ./src/api/mixins.js